// src/FileUpload.js
import React, { useCallback, useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import toast from 'react-hot-toast';
// (ลบ import useAuth เพราะเราจะรับ getAuthHeaders มาจาก props)

const API_URL = 'https://rys-backend.onrender.com/api';

// --- (1. ลบ getAuthHeaders เก่าทิ้ง) ---

// (ไอคอน)
const UploadIcon = () => (
  <svg className="h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// --- (2. รับ getAuthHeaders จาก props) ---
function FileUpload({ onUploadSuccess, currentImageUrl, getAuthHeaders }) {
  const [isLoading, setIsLoading] = useState(false);
  const [preview, setPreview] = useState(currentImageUrl || null);

  const onDrop = useCallback(async (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;

    setIsLoading(true);
    setPreview(URL.createObjectURL(file)); // (แสดงพรีวิวทันที)

    const formData = new FormData();
    formData.append('file', file);

    try {
      // (3. สร้าง Auth Header สำหรับ 'multipart/form-data')
      const authHeaders = getAuthHeaders(); // (เรียกใช้จาก props)
      authHeaders.headers['Content-Type'] = 'multipart/form-data'; // (Override)

      const response = await axios.post(`${API_URL}/upload`, formData, authHeaders);
      
      onUploadSuccess(response.data.file_url); 
      toast.success(response.data.msg);

    } catch (err) {
      console.error("Upload failed:", err);
      toast.error(err.response?.data?.msg || "Upload failed");
      setPreview(currentImageUrl || null); // (ถ้าล้มเหลว ให้กลับไปรูปเดิม)
    } finally {
      setIsLoading(false);
    }
  }, [onUploadSuccess, currentImageUrl, getAuthHeaders]); // (4. เพิ่ม getAuthHeaders)

  // (อัปเดต Preview เมื่อ currentImageUrl เปลี่ยนจากภายนอก)
  useEffect(() => {
    setPreview(currentImageUrl);
  }, [currentImageUrl]);


  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/gif': ['.gif'],
      'application/pdf': ['.pdf'], 
    },
    multiple: false
  });

  return (
    <div
      {...getRootProps()}
      className={`mt-1 border-2 border-dashed rounded-md p-6 text-center cursor-pointer transition-colors
        ${isDragActive ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-blue-400'}
        ${preview ? 'p-2' : 'p-6'}`}
    >
      <input {...getInputProps()} />
      
      {isLoading ? (
        <p>กำลังอัปโหลด...</p>
      ) : preview ? (
        <img src={preview} alt="Preview" className="w-full h-auto max-h-48 object-contain rounded-md" />
      ) : (
        <div className="flex flex-col items-center">
          <UploadIcon />
          <p className="mt-2 text-base text-gray-600">
            {isDragActive ? 'วางไฟล์ที่นี่...' : 'ลากไฟล์มาวาง หรือ คลิกเพื่อเลือกไฟล์'}
          </p>
          <p className="text-sm text-gray-500">(PNG, JPG, PDF)</p>
        </div>
      )}
    </div>
  );
}

export default FileUpload;